export default class DtoOperationReferencial {
    constructor(obj) {
        this.code = obj.code.toString()
        this.name = obj.name
    }
}
